import { Reducer } from 'redux';
import { HomeCardsState, HomeCardsTypes } from './types';

const INITIAL_STATE: HomeCardsState = {
  data: [],
  loading: false,
};

const reducer: Reducer<HomeCardsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HomeCardsTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case HomeCardsTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case HomeCardsTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
